import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(5),
    },
    header: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(8),
    },
    divider: {
        maxWidth: theme.breakpoints.values.md,
    },
    arcAutomarkerContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        marginTop: '-50px',
        marginBottom: '34px',
        maxWidth: '900px',
    },
    arcAutomarkerLabel: {
        color: 'rgba(0, 0, 0, 1)',
        font: 'Roboto Semibold',
        fontSize: '18px',
        fontWeight: 'bold',
    },
    arcAutomarkerChip: {
        fontWeight: 500,
        height: '28px',
        backgroundColor: '#f5f2f2ff',
        color: '#000000',
        borderRadius: '6px',
    },
    arcAutomarkerChipDraft: {
        border: '1px solid #7b1fa2',
    },
    arcAutomarkerChipLocked: {
        border: '1px solid #c2185b',
    },
    arcAutomarkerIconDraft: {
        fontSize: '18px',
        color: '#7b1fa2 !important',
    },
    arcAutomarkerIconLocked: {
        fontSize: '18px',
        color: '#c2185b !important',
    },
}));
export const screenSaveCancelStyles = (theme) => ({
    inlineWidthContainer: {
        width: 'auto',
        maxWidth: '100%',
    },
    inlineBelowActivityLogs: {
        position: 'static !important',
        bottom: 'auto !important',
        right: 'auto !important',
        width: '860px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        background: 'transparent',
        boxShadow: 'none',
        border: 'none',
        padding: 0,
        marginTop: 20,
        marginBottom: 15,
        paddingRight: theme?.spacing ? theme.spacing(2) : 20,
        gap: 12,
    },
});

export const updatedActivityLogStyles = {
    root: {
        width: 840,
        maxWidth: '100%',
    },
    accordionSummary: {
        marginTop: '34px',
    },
};